import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { baseUrl } from "../Univ";

function Invoice() {
  const { orderId } = useParams();
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    axios
      .get(baseUrl + `order-invoice/${orderId}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      })
      .then((res) => setInvoice(res.data));
  }, [orderId]);

  const handlePrint = () => {
    const printContent = document.getElementById("invoice-print").innerHTML;
    const original = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = original;
  };

  if (!invoice) return <h4>Loading Invoice...</h4>;

  return (
    <div className="container mt-4">
      <div id="invoice-print">
        {/* HEADER */}
        <div className="text-center mb-3">
          <h2>MGM eCart</h2>
          <hr />
        </div>

        {/* INVOICE META */}
        <div className="row mb-3">
          <div className="col-md-6">
            <h5>Bill To</h5>
            <p>
              {invoice.buyer.name}
              <br />
              {invoice.buyer.address}
              <br />
              Pincode: {invoice.buyer.pincode}
              <br />
              Email: {invoice.buyer.email}
            </p>
          </div>

          <div className="col-md-6 text-end">
            <p>
              <b>Invoice No:</b> {invoice.invoice_no}
            </p>
            <p>
              <b>Order ID:</b> {invoice.order_id}
            </p>
            <p>
              <b>Date:</b> {invoice.date}
            </p>
            <p>
              <b>Payment:</b> {invoice.payment_method}
            </p>
            <p>
              <b>Status:</b> {invoice.status}
            </p>
          </div>
        </div>

        {/* ITEMS TABLE */}
        <div style={{ overflowX: "auto" }}> {/* Responsive wrapper */}
          <table className="erp-table-modern" style={{ minWidth: "700px" }}>
            <thead className="table" style={{ color: "#000" }}>
              <tr>
                <th>#</th>
                <th style={{ width: "400px" }}>Product</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Total</th>
              </tr>
            </thead>

            <tbody>
              {invoice.items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>

                  {/* PRODUCT + SELLER */}
                  <td style={{ width: "400px", wordBreak: "break-word" }}>
                    <div style={{ fontWeight: "600" }}>{item.product_name}</div>
                    <div style={{ fontSize: "12px", color: "#666" }}>
                      {item.seller.shop_name}
                    </div>
                    <div style={{ fontSize: "11px", color: "#999" }}>
                      {item.seller.address}
                    </div>
                  </td>

                  <td>₹{item.price}</td>
                  <td>{item.qty}</td>
                  <td>₹{item.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* TOTALS */}
        <div className="text-end mt-3">
          <h6>Subtotal: ₹{invoice.subtotal}</h6>
          <h4>
            <b>Grand Total: ₹{invoice.total_amount}</b>
          </h4>
        </div>

        <hr />

        <p className="text-center">Thank you for shopping with us!</p>
      </div>

      {/* PRINT BUTTON */}
      <div className="text-center mt-4">
        <button className="btn btn-primary" onClick={handlePrint}>
          Print Invoice
        </button>
      </div>
    </div>
  );
}

export default Invoice;
